import { render, staticRenderFns } from "./modal_academic_appointment_form.vue?vue&type=template&id=090a5c7a"
import script from "./modal_academic_appointment_form.vue?vue&type=script&lang=js"
export * from "./modal_academic_appointment_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports